import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Bing",
  "use": "icon-Bing-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-Bing\"><path d=\"M500.736 338.773333l67.328 165.12 110.933333 49.92-221.866666 126.72V139.093333L298.666667 85.333333v683.52L457.130667 853.333333 853.333333 630.613333v-172.8z\" fill=\"#6563FF\" p-id=\"3981\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol